import { render, staticRenderFns } from "./SafeProjects.vue?vue&type=template&id=57e5706c&scoped=true&"
import script from "./SafeProjects.vue?vue&type=script&lang=js&"
export * from "./SafeProjects.vue?vue&type=script&lang=js&"
import style0 from "./SafeProjects.vue?vue&type=style&index=0&id=57e5706c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e5706c",
  null
  
)

export default component.exports